module.exports = __webpack_public_path__ + "static/media/Soleil-Semibold.5a508cb3.otf";